"use client";

import type { VideoProps } from '../types/video';

import IndividualVideoPlayer from './individual-video-player';

const RecapVideoSection = ({ videoData, videoId }: VideoProps) => {
  return (
    <section className="mb-8">
      <div className="surface-card rounded-xl shadow-lg border border-subtle overflow-hidden">
        <div className="h-2 gradient-primary" />
        <div className="p-6">
          {videoData && videoId && videoData.src && (
            <div className="explanation-box">
              <div className="text-center mb-4">
                <h4 className="font-semibold text-primary text-lg">
                  Watch & Learn
                </h4>
                <p className="text-xs sm:text-sm text-secondary">
                  Review key concepts and takeaways
                </p>
              </div>
              <IndividualVideoPlayer
                analyticsCategory="page"
                description={videoData.description}
                lazy={false}
                src={videoData.src}
                thumbnail={videoData.thumbnail}
                title={videoData.title}
                videoId={videoId}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default RecapVideoSection;
